import React from 'react';
import { Text } from '../../components/Text';
import { Wrapper } from '../../components/Wrapper';
import { Divider } from '../../components/Divider';
import { Subtitle } from '../../components/Text/Subtitle';
import { HeroSection } from '../../components/HeroSections/FirstPage';
import { StrongWordTextSection } from '../../components/StrongWordTextSection';
import { Layout } from '../../components/Layout';
import { ImagesWithShadowList } from '../../components/ImagesWithShadowList';
import { Quote } from '../../components/Quote';
import { HeroContainer } from '../../components/HeroСontainer';
import { References } from '../../components/References';
import styles from './SecondaryTemplate.styles';

const SecondaryTemplate = ({
  pageContext: {
    PageData: {
      seo,
      hero,
      text,
      titles,
      imagesWithShadow,
      sectionWithPostFirst,
      sectionWithPostsSecond,
      navigation,
      imagesCommon,
      quoteOne,
      quoteTwo,
      references,
      supported,
    },
  },
  location,
}) => (
  <Layout
    props={seo}
    navigation={navigation}
    locationPathName={location.pathname}
    imagesCommon={imagesCommon}
    logo={imagesCommon.logoHeadAdv}
    supported={supported}
    homeSection={hero.homeSection}>
    <div className="article" css={styles(hero.backgroundColor, hero.backgroundColorFooter)}>
      <HeroContainer propsHero={hero} propsCommon={imagesCommon}>
        <HeroSection props={hero} />
      </HeroContainer>
      <Divider height={8} />
      <Wrapper maxWidth={'840px'} width={'100%'} mobileWidth={'90%'}>
        {titles.first && (
          <>
            <Subtitle
              text={titles.first}
              fontSize={24}
              lineHeight={28}
              maxWidth={'100%'}
              width={'100%'}
              fontWeight={'normal'}
            />
            <Divider height={4} heightMobile={6} />
          </>
        )}
        <Text text={text.first} width={'100%'} />
        <Divider height={5} heightMobile={8} />
        {quoteOne && (
          <div className="article__posts-block-quote">
            <Text text={text.textQuoteOne} width={'47%'} />
            <Quote props={quoteOne} />
          </div>
        )}
        <Divider height={6} heightMobile={6} />
      </Wrapper>
      <Wrapper maxWidth={'1024px'} width={'100%'} mobileWidth={'100%'}>
        <ImagesWithShadowList images={imagesWithShadow} />
      </Wrapper>
      <Divider height={6} heightMobile={6} />
      <Wrapper maxWidth={'840px'} width={'100%'} mobileWidth={'90%'}>
        {titles.second && (
          <>
            <Subtitle
              text={titles.second}
              fontSize={24}
              lineHeight={28}
              maxWidth={'100%'}
              width={'100%'}
              fontWeight={'normal'}
            />
            <Divider height={4} heightMobile={6} />
          </>
        )}
        <Text text={text.second} width={'100%'} />
      </Wrapper>
      <Divider height={6} heightMobile={8} />
      <div className="article__posts-block-background article__posts-block-background--small-size" />
      <Wrapper maxWidth={'1024px'} width={'100%'} mobileWidth={'100%'}>
        <div className="article__posts-block-first">
          <StrongWordTextSection
            title={sectionWithPostFirst.title}
            posts={sectionWithPostFirst.posts}
            width={'1024px'}
            height={'339'}
            subtitleWidth={'100%'}
            subtitleMaxWidth={'400px'}
            fontSizeLastWord={72}
            lineHeightLastWord={90}
            marginFirstColumn={{
              top: 63,
              right: 0,
              bottom: 0,
              left: 0,
            }}
            marginSecondColumn={{
              top: 32,
              right: 0,
              bottom: 0,
              left: 16,
            }}
          />
        </div>
      </Wrapper>
      <Divider height={10} heightMobile={8} />
      <Wrapper maxWidth={'840px'} width={'100%'} mobileWidth={'90%'}>
        {titles.third && (
          <>
            <Subtitle
              text={titles.third}
              fontSize={24}
              lineHeight={28}
              maxWidth={'100%'}
              width={'100%'}
              fontWeight={'normal'}
            />
            <Divider height={4} heightMobile={6} />
          </>
        )}
        {quoteTwo && (
          <div className="article__posts-block-quote">
            <Text text={text.textQuoteTwo} width={'47%'} />
            <Quote props={quoteTwo} />
          </div>
        )}
        <Divider height={4} heightMobile={6} />
        <Text text={text.third} width={'100%'} />
      </Wrapper>
      <Divider height={4} heightMobile={6} />
      <Wrapper maxWidth={'840px'} width={'100%'} mobileWidth={'90%'}>
        {titles.fourth && (
          <>
            <Subtitle
              text={titles.fourth}
              fontSize={24}
              lineHeight={28}
              maxWidth={'100%'}
              width={'100%'}
              fontWeight={'normal'}
            />
            <Divider height={4} heightMobile={6} />
          </>
        )}
        {text.fourth && <Text text={text.fourth} width={'100%'} />}
        <Divider height={10} heightMobile={10} />
      </Wrapper>
      <div className="article__posts-block-background-footer">
        <Wrapper maxWidth={'1024px'} width={'100%'} mobileWidth={'100%'}>
          <div className="article__posts-block-second">
            <StrongWordTextSection
              title={sectionWithPostsSecond.title}
              posts={sectionWithPostsSecond.posts}
              width={'1024px'}
              height={'339'}
              subtitleWidth={'100%'}
              subtitleMaxWidth={'400px'}
              fontSizeLastWord={72}
              lineHeightLastWord={90}
              align-first-column="0 center"
              alignFirstColumnFlexContainer={{
                alignItems: 'flex-start',
                justifyContent: 'center',
              }}
              marginSecondColumn={{
                top: 48,
                right: 0,
                bottom: 0,
                left: 16,
              }}
            />
          </div>
        </Wrapper>
      </div>
      {references && (
        <Wrapper maxWidth={'1024px'} width={'100%'} mobileWidth={'90%'}>
          <Divider height={6} heightMobile={8} />
          <References references={references} />
          <Divider height={6} heightMobile={8} />
        </Wrapper>
      )}
    </div>
  </Layout>
);

export default SecondaryTemplate;
